import React, {Component} from "react";
import "./TourStepContent.css";

class TourStepContentSmall extends Component {
    render(){
        const {
            title = "Assets",
            subtitle = "Si es la primera vez aquí, te enseñaremos paso a paso paraque puedas trabajar correctamente con Bunkey"
        } = this.props;

        return (
            <React.Fragment>
                <div
                    className="tour-step-content-cnt"
                >
                    <div>
                        <h1 className="tour-step-content-h1">{title}</h1>
                        <p className="tour-step-content-p">{subtitle}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TourStepContentSmall;